import {tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {getMessageFromException} from '../utilities/Util';
import {NotificationService} from './NotificationService';
import {Observable} from 'rxjs';
import {
    CompanyAddressChangeRequestClient,
    CompanyAddressChangeRequestViewModel,
    PagedListOfCompanyAddressChangeRequestViewModel
} from './api.client';

@Injectable()
export class CompanyAddressChangeRequestService {

    constructor(private _apiClient: CompanyAddressChangeRequestClient,
                private _notificationService: NotificationService) {
    }

    createRequest(request: CompanyAddressChangeRequestViewModel, successMessage?: string): Observable<CompanyAddressChangeRequestViewModel> {
        return this._apiClient.createRequest(request).pipe(
            tap({
                next: () => {
                    this._notificationService.showSuccess(successMessage || 'Address change request submitted successfully.');
                },
                error: (err) => {
                    this._notificationService.showError(getMessageFromException(err));
                }
            })
        );
    }

    getPendingRequests(
        limit: number,
        offset: number,
        sortName: string,
        descending: boolean
    ): Observable<PagedListOfCompanyAddressChangeRequestViewModel> {
        return this._apiClient.getPendingRequests(
            limit || 10,
            offset || 0,
            sortName || 'EnteredDate',
            null,
            descending
        ).pipe(
            tap({
                error: () => {
                    this._notificationService.showError('Error loading address change requests.');
                }
            })
        );
    }

    approveRequest(id: string): Observable<CompanyAddressChangeRequestViewModel> {
        return this._apiClient.approveRequest(id).pipe(
            tap({
                next: () => {
                    this._notificationService.showSuccess('Address change request approved.');
                },
                error: (err) => {
                    this._notificationService.showError(getMessageFromException(err));
                }
            })
        );
    }

    denyRequest(id: string): Observable<CompanyAddressChangeRequestViewModel> {
        return this._apiClient.denyRequest(id).pipe(
            tap({
                next: () => {
                    this._notificationService.showSuccess('Address change request denied.');
                },
                error: (err) => {
                    this._notificationService.showError(getMessageFromException(err));
                }
            })
        );
    }
}
